import OtpDeliverySelectorSFC from "./OtpDeliverySelector.vue";
export type { IOtpDeliverySelectorEmits } from "./emits";
export type { IOtpDeliverySelectorProps } from "./props";
export const OtpDeliverySelector = OtpDeliverySelectorSFC;
